import { createUseStyles } from 'react-jss';

/**
  * @desc shortcut for creating styles via react-jss
  *
  * @param {object} styles jss definitions library
  *
  * @returns {object} css library
*/
function createStyle(styles) {
  return createUseStyles(styles, { generateId: (rule) => rule.key });
}
export default createStyle;
